import { AccountRole } from 'models/account.model';

export enum RightsType {
  Branch = 'branch',
  Organization = 'org',
}

export enum Subject {
  /** Core Data → Customer */
  Customer = 'Customer',

  /** Core Data → Object */
  Objekt = 'Objekt',

  /** Core Data → Conditions */
  Conditions = 'Conditions',

  /** Core Data → All Text Templates */
  Templates = 'Templates',

  /** Core Data → Foreign Articles */
  Articles = 'Articles',

  /** Settings → Branch */
  Branch = 'Branch',

  /** Settings → Branch → Offer Text */
  OfferTemplates = 'OfferTemplates',

  /** Settings → Branch → Offer Template */
  OfferTemplateSettings = 'OfferTemplateSettings',

  /** Settings → Branch → Settings */
  OfferSettings = 'OfferSettings',

  /** Settings → Team */
  Account = 'Account',

  /** Settings → Customer → Contact Person */
  ContactPerson = 'ContactPerson',

  /** Settings → Branches */
  Branches = 'Branches',

  /** Header → Settings (Cog Icon) */
  HeaderNavSettings = 'HeaderNavSettings',

  /** Stammdaten → Kunden → Import */
  ImportCustomer = 'ImportCustomer',

  /** Stammdaten → Kunden → Export */
  ExportCustomer = 'ExportCustomer',

  /** Stammdaten → Meine Artikel → Import */
  ImportArticles = 'ImportArticles',

  /** Stammdaten → Meine Artikel → Export */
  ExportArticles = 'ExportArticles'
}

export enum Action {
  /** Create & Read & Update & Delete */
  Manage = 'manage',
  Create = 'create',
  Read = 'read',
  Update = 'update',
  Delete = 'delete',
}

export interface AccountRoleRightsDef {
  [AccountRole.USER]: Action[] | never;
  [AccountRole.ADMIN]: Action[] | never;
  [AccountRole.SUPERADMIN]: Action[] | never;
}
export interface AccountRightsDef {
  [RightsType.Branch]?: AccountRoleRightsDef;
  [RightsType.Organization]?: AccountRoleRightsDef;
}

export type AccountRightsDefs = {
  [key in Subject]: AccountRightsDef;
}

export type AccountRoleRightsDefs = {
  [key in Subject]: AccountRoleRightsDef;
}
